import { Auth0Provider, AuthConnect, AuthResult, TokenType } from '@ionic-enterprise/auth';
import { ConfigSettingsService } from '../../../providers';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import type { ProviderURLInfo } from '@ionic-enterprise/auth/dist/esm/definitions';

export class IdSrvProvider extends Auth0Provider {
  constructor(
    private readonly http: HttpClient,
    private readonly config: ConfigSettingsService,
  ) {
    super();
  }

  public override async logoutRequest(auth: AuthResult): Promise<ProviderURLInfo> {
    if (!auth) {
      throw new Error('auth result is missing');
    }

    const clientId = auth.provider.options.clientId;
    const manifest = auth.provider.manifest;

    const token = await AuthConnect.getToken(TokenType.refresh, auth);
    if (!token) {
      throw new Error('could not get id token from auth result');
    }

    await this.revokeRefreshToken(manifest['revocation_endpoint'], token, clientId);

    const postLogoutRedirectUri = this.config.appSettings.connection.postLogoutRedirectUri;

    if (!postLogoutRedirectUri) {
      throw new Error('Post logout redirect URI is missing');
    }

    const url = manifest['end_session_endpoint'];
    const params = {
      post_logout_redirect_uri: postLogoutRedirectUri,
      client_id: clientId,
    };

    return {
      url,
      params,
    };
  }

  private async revokeRefreshToken(revocationUrl: string, refreshToken: string, clientId: string): Promise<void> {
    const headers = new HttpHeaders({ 'Content-type': 'application/x-www-form-urlencoded; charset=utf-8' });
    const body = new HttpParams().set('client_id', clientId).set('token', refreshToken);

    await firstValueFrom(this.http.post(revocationUrl, body, { headers }));
  }
}
